import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import './FloatingContactWidget.css';

const FloatingContactWidget = () => {
  const phoneNumber = '+918766346052';
  const whatsappLink = `https://wa.me/918766346052?text=${encodeURIComponent(
    'Hi WhiteLabelDevs, I would like to discuss a project.',
  )}`;

  return (
    <div className="floating-contact-widget">
      <a
        href={whatsappLink}
        className="floating-btn floating-btn-whatsapp"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle size={20} />
        <span>WhatsApp</span>
      </a>
      <a
        href={`tel:${phoneNumber}`}
        className="floating-btn floating-btn-phone"
        aria-label="Call WhiteLabelDevs"
      >
        <Phone size={20} />
        <span>Call Now</span>
      </a>
    </div>
  );
};

export default FloatingContactWidget;
